import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Modal from './ui/Modal';
import { containerVariants, itemVariants, iconVariants } from '../utils/animations';

const TYPE_ICONS = {
  feature: '🎉',
  update: '📢',
  info: 'ℹ️',
};

function AnnouncementModal({ announcement, onDismiss }) {
  if (!announcement) return null;

  const icon = TYPE_ICONS[announcement.type] || TYPE_ICONS.info;

  return (
    <Modal onClose={onDismiss} maxWidth="max-w-sm sm:max-w-md">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {/* Icon */}
        <motion.div className="text-center mb-4" variants={iconVariants}>
          <span className="text-5xl">{icon}</span>
        </motion.div>

        {/* Title */}
        <motion.h2
          className="text-xl font-bold text-center text-puzzle-text mb-3"
          variants={itemVariants}
        >
          {announcement.title}
        </motion.h2>

        {/* Message */}
        <motion.p
          className="text-center text-puzzle-text-secondary mb-6"
          variants={itemVariants}
        >
          {announcement.message}
        </motion.p>

        {/* Buttons */}
        <motion.div className="flex justify-center gap-3" variants={itemVariants}>
          {announcement.actionLink && announcement.actionLabel && (
            <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
              <Link
                to={announcement.actionLink}
                onClick={onDismiss}
                className="inline-block px-8 py-3 bg-puzzle-blue text-white font-medium rounded-full hover:bg-blue-600 transition-colors"
              >
                {announcement.actionLabel}
              </Link>
            </motion.div>
          )}
          <motion.button
            onClick={onDismiss}
            type="button"
            className={`px-8 py-3 font-medium rounded-full transition-colors ${
              announcement.actionLink
                ? 'border-2 border-puzzle-border text-puzzle-text hover:border-puzzle-text-secondary'
                : 'bg-puzzle-blue text-white hover:bg-blue-600'
            }`}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            Got it!
          </motion.button>
        </motion.div>
      </motion.div>
    </Modal>
  );
}

AnnouncementModal.propTypes = {
  announcement: PropTypes.shape({
    id: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['feature', 'update', 'info']),
    actionLink: PropTypes.string,
    actionLabel: PropTypes.string,
  }),
  onDismiss: PropTypes.func.isRequired,
};

AnnouncementModal.defaultProps = {
  announcement: null,
};

export default AnnouncementModal;
